import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import { EnhancedMembershipsList } from "../../components/memberships-list/enhanced-memberships-list";
import { Button, Typography, Link as MuiLink } from "@mui/material";
import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Link } from "react-router";
import { Pages } from "../../utils";
import { useState } from "react";
import { PolicyPopup } from "./policy-popup";
import { DesignerAddOnOffer } from "../../components/designer-add-on-offer";
import { PaymentFrequency } from "../../__generated__/types";

export const MembershipPricingPage = () => {
  const [showPolicyPopup, setShowPolicyPopup] = useState(false);
  
  return (
    <div className="page membership-pricing-page">
      <MaterialHero title="DESIGNER MEMBERSHIP LEVELS" />
      <LandingPageSection className="text-center">
        <Typography
          variant="h4"
          component="h2"
          sx={{ mb: "16px" }}
          className="font-size-5 font-body text-pink"
        >
          Transparent Pricing & Results Reporting
        </Typography>
        <Typography
          variant="body1"
          sx={{ mx: "auto", mb: "40px" }}
          className="font-size-3 description contain-text"
        >
          We offer one marketing membership designed for qualified interior
          designers who want regional visibility and Smart-Guild matching.{" "}
          <MuiLink
            color={"purple" as any}
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => setShowPolicyPopup(true)}
          >
            View our cancellation policy.
          </MuiLink>
        </Typography>
        <LandingPageSection className="text-left contain-text" sx={{ mt: "-60px" }}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert variant="outlined" severity="info" sx={{ height: "100%" }}>
              <>
                <Typography
                  sx={{ fontWeight: 600, mb: "16px" }}
                  variant="body1"
                  className="font-size-4 text-left font-body"
                >
                  How billing works
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mb: "0", mx: "auto", display: "block" }}
                  className="font-size-4 text-left font-body"
                >
                  Your Annual Design Membership consists of an annual one-time
                  Marketing fee of $3,500 that is non-refundable, and a $100/month
                  Platform fee (12 monthly payments). Your first payment will be $3,600.
                  Your Annual Design Membership renews annually. The monthly
                  platform billing continues until the account is canceled.
                </Typography>
              </>
            </Alert>
          </Stack>
        </LandingPageSection>

        <EnhancedMembershipsList 
          variant="designer"
          showPlaceholders={false}
          showBetaPlans={false}
          defaultFrequency={PaymentFrequency.Annually}
          showFrequencyToggle={false}
          showApplyNowButton
          applyNowLabel="APPLY NOW"
          applyNowTo={Pages.SIGNUP}
          additionalCards={[<DesignerAddOnOffer useMembershipCardShell key="designer-addon-offer" />]}
        />

      </LandingPageSection>

      <LandingPageSection className="pink-section text-center">
        <Typography
          mb="20px"
          variant="h4"
          sx={{ fontWeight: 600 }}
          className="font-size-5 font-body title"
        >
          Start Fueling Your Future With Home Design Guild.
        </Typography>
        <Typography
          mb="52px"
          variant="h6"
          component="p"
          fontWeight={400}
          className="text-white"
        >
          Join now and experience the difference a designer-first platform can
          make.
        </Typography>
        <Button
          component={Link}
          to={Pages.SIGNUP}
          color={"white" as any}
          variant="contained"
          size="large"
          sx={{ fontWeight: 600 }}
          className="font-size-3 font-body"
        >
          Apply Now
        </Button>
      </LandingPageSection>
      <PolicyPopup
        onClose={() => setShowPolicyPopup(false)}
        visible={showPolicyPopup}
      />
    </div>
  );
};
